import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../../store/actions/notificationAction';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import {  Grid } from '@material-ui/core';

import addServicesRemote from '../../../../api/addServicesRemote';
import CommonAdditionalService from '../commonAdditionalService/CommonAdditionalService';

import Cart from '../../../../models/Cart';
import CartItem from '../../../../models/CartItem';
import FeeTotal from '../../../../models/FeeTotal';
import FeeParams from '../../../../models/FeeParams';
import ApiResponse from '../../../../models/ApiResponse';
import CartService from '../../../../models/CartService';
import ResponseError from '../../../../models/ResponseError';
import AddServicesUnits from '../../../../models/AddServicesUnits';
import AddServicesTariff from '../../../../models/AddServicesTariff';

import breakdownByHouseBillStyles from './breakdownByHouseBill.module.css';
import commonAddServiceStyles from '../commonAdditionalService/commonAdditionalService.module.css';
import commonStyles from '../../../common/common.module.css';

import { findCartItemByCodeAndNumber } from '../../../../utils/cartService';
import { debounce } from '../../../../utils/debounce';
import { formatCurrency } from '../../../../utils/currencyFormatter';
import { CART_ITEM_SCHEMA } from '../../../../utils/cartService';

const BREAK_BY_HOUSE_BILL_RAW_NAME: string = 'breakdown_hawb';
const PAY_BY_HOUSE_BILL_RAW_NAME: string = 'per_hawb';
const PAY_BY_HOUSE_BILL_NO_IMPORT_FEE_RAW_NAME: string = 'per_hawb_exclude_import_service';
const DEBOUNCE_TIME_MS: number = 1200;
const TEXT_FIELD_PADDINGS: string = '8px 12px';
const styles = (theme: any) => ({

});

interface BreakdownByHouseBillProps {
  classes: any;
  serviceDetails: AddServicesUnits;
  total: number;
  cart: Cart;
  selectedAwbCode: string;
  selectedAwbNumber: string;
  selectedAwbVer: number;
  getFeeRequest: Function;
  additionalServiceAndTariff: AddServicesTariff;
  receiveError: Function;
  handleChange: any;
  additionalInformation: string; // TODO: handle it
  getBreakByHouseBillInputValue: Function;
  payByHouseBillBreakByError: boolean;
  changeDoAdd: Function;
  allowedService: boolean;
  isServiceInCart: boolean;
};

interface BreakdownByHouseBillState {
  cartItem: CartItem;
  payByHouseBillTotal: number;
  payByHouseBillError: boolean;
  inputValue: string;
  addInfoBreakBy: string;
  addInfoPayBy: string;
  hasPayByService: boolean;
};

class BreakdownByHouseBill extends Component<BreakdownByHouseBillProps, BreakdownByHouseBillState> {

  state = {
    cartItem: CART_ITEM_SCHEMA,
    payByHouseBillTotal: 0,
    payByHouseBillError: false,
    inputValue: '',
    addInfoBreakBy: '',
    addInfoPayBy: '',
    hasPayByService: false
  }

  componentDidMount() {

    const optionalParams: FeeParams = {};
    const cartItem: CartItem | undefined = findCartItemByCodeAndNumber(this.props.selectedAwbCode, this.props.selectedAwbNumber, this.props.cart);

    if (cartItem) {
      this.setState({ cartItem });
      this.checkContainsServicePayByHouseBill(cartItem);

      optionalParams.kg = cartItem.weight;
      this.props.getFeeRequest(optionalParams);

      const foundServiceBreakBy: CartService | undefined = cartItem.services.find((cartService: CartService) => {
        return cartService.type === BREAK_BY_HOUSE_BILL_RAW_NAME;
      });

      if (foundServiceBreakBy) {
        this.setState({ addInfoBreakBy: foundServiceBreakBy.additional_info });
      }
    }
  }

  checkContainsServicePayByHouseBill = (cartItem: CartItem): void => {

    const cartItemServices: Array<CartService> = [...cartItem.services];

    const foundService: CartService | undefined = cartItemServices.find((cartService: CartService) => {
      return cartService.type === PAY_BY_HOUSE_BILL_RAW_NAME || cartService.type === PAY_BY_HOUSE_BILL_NO_IMPORT_FEE_RAW_NAME;
    });

    this.setState({ hasPayByService: foundService !== undefined });
  }

  componentDidUpdate(prevProps: BreakdownByHouseBillProps) {

    if (prevProps.payByHouseBillBreakByError !== this.props.payByHouseBillBreakByError) {
      this.setState({ payByHouseBillError: this.props.payByHouseBillBreakByError });
    }

    if (prevProps.total !== this.props.total || this.state.hasPayByService) {

        this.props.getBreakByHouseBillInputValue(this.props.total);
      
    }
  }

  getPayByHouseBillFeeRequest = (params: FeeParams): void => {

    let payPerHawbServiceName = '';
    if(this.props.additionalServiceAndTariff.per_hawb) {
      payPerHawbServiceName = PAY_BY_HOUSE_BILL_RAW_NAME;
    } else if(this.props.additionalServiceAndTariff.per_hawb_exclude_import_service) {
      payPerHawbServiceName = PAY_BY_HOUSE_BILL_NO_IMPORT_FEE_RAW_NAME;
    }

    addServicesRemote.getFee(payPerHawbServiceName, this.props.selectedAwbCode, this.props.selectedAwbNumber, this.props.selectedAwbVer, params).then((res: ApiResponse<FeeTotal>) => {

      const payByHouseBillTotal: FeeTotal | undefined = res.result;
      const error: ResponseError | undefined = res.error;

      if (payByHouseBillTotal) {
        this.setState({ payByHouseBillTotal: payByHouseBillTotal.total });
      } 

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  checkIsNumber = (input: string): void => {

    if (input.trim().length > 0) {

      const numberRegex: RegExp = new RegExp(/^[0-9]+$/);
      const hasError: boolean = numberRegex.test(input) ? false : true;
      
      if(hasError) {
        this.setState({ payByHouseBillTotal: 0 });
        this.setState({ payByHouseBillError: hasError });
      } else {
        this.calculateHouseBillTotalPerUnit(input);
      }
    }

    if (input.trim().length === 0) {

      this.setState({ payByHouseBillTotal: 0 });
    }
  }

  checkIsNumberAndRequest = debounce(this.checkIsNumber, DEBOUNCE_TIME_MS);

  calculateHouseBillTotalPerUnit = (stringValue: string): void => {

    const value: number = +stringValue;
    const optionalParams: FeeParams = { number_hawb: value };

    this.props.getBreakByHouseBillInputValue(value);
    this.getPayByHouseBillFeeRequest(optionalParams);
  }

  handleInputValueChange = (inputValue: string): void => {
    this.setState({ inputValue: inputValue });
  }

  handleAdditionalInformationPayBy = (event: any): void => {

    this.props.handleChange(event, 'additionalInformation');
    this.setState({ addInfoPayBy: event.target.value });
  }

  handleAdditionalInformationBreakBy = (event: any): void => {

    this.props.handleChange(event, 'additionalInformationBreakBy');
    this.setState({ addInfoBreakBy: event.target.value });
  }

  doUpdateService = (): void => {

    const doAdd: boolean = this.state.hasPayByService;
    this.props.changeDoAdd(!doAdd);
  }

  render () {

    const { classes, serviceDetails, total } = this.props;

    let payPerHawbTariff = this.props.additionalServiceAndTariff.per_hawb || this.props.additionalServiceAndTariff.per_hawb_exclude_import_service;

    return (

      <FormControl fullWidth={ true }>

        { !this.state.hasPayByService &&
          <div className={` ${ breakdownByHouseBillStyles.bdContainer } ${ breakdownByHouseBillStyles.flex }` }>
            <h3 className={ `${ commonStyles.header } ${breakdownByHouseBillStyles.title}` }>Breakdown by house bill Fee</h3>
            <div className={ breakdownByHouseBillStyles.horizontalLine }></div>
          </div>
        }

        <div className={ breakdownByHouseBillStyles.flexContainer }>
          
          <Grid container className={ breakdownByHouseBillStyles.gridContainer }>
            <Grid item md={4} sm={4} xs={12} direction="row" className={ breakdownByHouseBillStyles.gridItem }>
              <label className={ commonStyles.inputLabel }> Cost Per Unit</label>
              <TextField
                disabled
                label=""
                defaultValue={ formatCurrency(serviceDetails.cost_per_kg_usd ? serviceDetails.cost_per_kg_usd : 0, 2, '$') + ' / KG' }
                variant="outlined"
                inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
                InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
                fullWidth
              />
            </Grid>

            <Grid item  md={4} sm={4} xs={12} direction="row" className={ breakdownByHouseBillStyles.gridItem }>
              <label className={ commonStyles.inputLabel }>Enter Nbr Units </label>              
              <TextField
                disabled
                label=""
                variant="outlined"
                value={ this.state.cartItem.weight }
                inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
                InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
                InputLabelProps={{ style: { fontWeight: 'bold' } }}
                fullWidth
              />
            </Grid>
            
            <Grid item md={4} sm={4} xs={12} direction="row" className={ breakdownByHouseBillStyles.gridItem }>
              <label className={ commonStyles.inputLabel }> Total Cost </label>              
              <TextField
                disabled
                label=""
                value={ formatCurrency(total, 2, '$') }
                variant="outlined"
                inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
                InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
                InputLabelProps={{ style: { fontWeight: 'bold' } }}
                fullWidth
              />
            </Grid>
          </Grid>        
          
        </div>

        <div className={ breakdownByHouseBillStyles.addInfoWrapper }>
          <div className={ commonStyles.inputLabelWrapper } >
            <label className={ commonStyles.inputLabel }> Additional information to GHA </label>
            <TextField
              fullWidth={ true }
              id="outlined-disabled"
              label=""
              variant="outlined"
              onChange={
                (event) => {
                  this.handleAdditionalInformationBreakBy(event);
                  this.doUpdateService();
                }
              }
              value={ this.state.addInfoBreakBy }
              inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
              InputProps={{ classes: { notchedOutline: classes.overrideBorder } }}
              InputLabelProps={{ shrink: true }}
              disabled={ !this.props.allowedService && !this.props.isServiceInCart }
            />
          </div>        
        </div>

        { !this.state.hasPayByService &&
          <div className={ breakdownByHouseBillStyles.payByHouseBillWrapper }>

            <div className={` ${ breakdownByHouseBillStyles.bdContainer } ${ breakdownByHouseBillStyles.flex }` }>
              <h3 className={`${commonStyles.header} ${breakdownByHouseBillStyles.payByHouseBillTitle}`}>Pay by house bill Fee</h3>
              <div className={ breakdownByHouseBillStyles.horizontalLine }></div>
            </div>

            <CommonAdditionalService
              serviceDetails={ payPerHawbTariff as AddServicesUnits }
              isNumber={ this.checkIsNumberAndRequest }
              error={ this.state.payByHouseBillError }
              value={ this.state.inputValue }
              total={ this.state.payByHouseBillTotal }
              handleChange={
                (event: any, propertyName?: string) => {
                  
                  if (propertyName === 'additionalInformation') {
                    this.handleAdditionalInformationPayBy(event);
                  } else {
                    this.handleInputValueChange(event.target.value);
                  }
                }
              }
              additionalInformation={ this.state.addInfoPayBy }
              allowedService={ this.props.allowedService }
              isServiceInCart={ this.props.isServiceInCart }
            />
          </div>
        }
      </FormControl>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    cart: state.cart,
    additionalServiceAndTariff: state.additionalService
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(BreakdownByHouseBill));